import { Theme } from '@material-ui/core/styles/createTheme';
import makeStyles from '@material-ui/core/styles/makeStyles';
import colors from './colors';

export default makeStyles((theme: Theme) => ({
  root: {
    '& th, & td': {
      padding: theme.spacing(1),
    },
    '& th:last-child, & td:last-child': {
      '@media (max-width: 670px)': { padding: theme.spacing(1, 0) },
    },
    '& .MuiTableCell-root': { '@media (max-width: 480px)': { padding: theme.spacing(1, 0.5) } },
  },
  category: {
    fontWeight: 'bold',
    '& td': {
      paddingTop: '5px',
      paddingBottom: '5px',
      color: '#fff',
      backgroundColor: `${colors.IK5} !important`,
    },

    '& .categoryTitle': {
      textAlign: 'left',
      fontSize: '22px',
      whiteSpace: 'nowrap',
      verticalAlign: 'middle',
      '@media (max-width: 1090px)': { fontSize: '18px' },
      '@media (max-width: 770px)': { fontSize: '17px' },
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        paddingTop: '5px',
        paddingBottom: '3px',
      },
    },
    '& .categoryShare': {
      fontSize: '22px',
      '@media (max-width: 1090px)': { fontSize: '18px' },
      '@media (max-width: 770px)': { fontSize: '17px' },
      [theme.breakpoints.down('xs')]: {
        fontSize: '14px',
        paddingTop: '5px',
        paddingBottom: '3px',
      },
      '@media (max-width: 400px)': { fontSize: '12px !important' },
    },
  },
  shareTitle: {
    width: '160px',
  },
  assetRow: {
    [theme.breakpoints.down('xs')]: {
      '& .MuiTableCell-root': { fontSize: '12px' },
    },
  },
  isinCol: {
    '@media (max-width: 480px)': { display: 'none' },
  },
  isinBlock: {
    display: 'none',
    '@media (max-width: 480px)': { display: 'block' },
  },
  kiidCol: {
    '@media (max-width: 400px)': { display: 'none' },
  },
  kiidBlock: {
    display: 'none',
    '@media (max-width: 400px)': { display: 'block' },
  },
}));
